module.exports = __webpack_public_path__ + "media/images/app/about/slider-1e62e46899a7d792b6b09a0cfec7809f.webp";